module.exports = __webpack_public_path__ + "img/header-2.23b3608.jpg";